// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PublisherIcon2_publisherIcon__Dc\\+TS {\n  width: auto;\n  height: 28px;\n  object-fit: cover;\n}\n", "",{"version":3,"sources":["webpack://./src/components/publisherIcon2/PublisherIcon2.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".publisherIcon {\n  width: auto;\n  height: 28px;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"publisherIcon": "PublisherIcon2_publisherIcon__Dc+TS"
};
export default ___CSS_LOADER_EXPORT___;
